import { render } from "./MailingList.vue?vue&type=template&id=12d93eba"
import script from "./MailingList.vue?vue&type=script&lang=js"
export * from "./MailingList.vue?vue&type=script&lang=js"
script.render = render

export default script